import React from "react";

const CheckMarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28.111"
      height="18"
      viewBox="0 0 28.111 22.192">
      <defs>
        <style dangerouslySetInnerHTML={{ __html: ".a{fill:#fff;}" }} />
      </defs>
      <g transform="translate(0.001 -53.907)">
        <g transform="translate(-0.001 53.907)">
          <path
            className="a"
            d="M27.6,54.273a1.48,1.48,0,0,0-2.088.139l-15.754,18L2.558,64.731A1.48,1.48,0,0,0,.4,66.756l8.322,8.877A1.484,1.484,0,0,0,9.8,76.1h.025a1.475,1.475,0,0,0,1.089-.5L27.745,56.361A1.48,1.48,0,0,0,27.6,54.273Z"
            transform="translate(0.001 -53.907)"
          />
        </g>
      </g>
    </svg>
  );
};

export default CheckMarkIcon;
